<template>
  <div id="app">
    <v-app>

      <v-main>

        <!-- ヘッダーナビゲーション -->
        <v-app-bar v-if="isMobileDevice()" dark app max-width="100vw" hide-on-scroll
          style="background: rgba(0,0,0,.35)">

          <v-app-bar-nav-icon @click.stop="drawer = !drawer" dark></v-app-bar-nav-icon>

          <v-spacer></v-spacer>

          <v-toolbar-title>
            <a href="#app" v-smooth-scroll>
              <v-img :src="cp_logo_w" max-height="20px" contain></v-img>
            </a>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-menu offset-y left open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon class="pa-3">mdi-earth</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="changeLocale">
                <v-list-item-title text type="button" class="text--white">
                  {{$t("LP.change_locale")}}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        </v-app-bar>

        <!-- ハンバーガーメニュー -->
        <v-navigation-drawer v-if="isMobileDevice()" v-model="drawer" color="black" app>
          <v-list nav dense class="py-10">

            <v-list-item class="py-2" v-for="menu in menus" :key="menu.title">
              <v-list-item-title class="text-body-1">
                <v-btn text :href="menu.url" v-smooth-scroll @click.stop="drawer = !drawer">
                  {{menu.title}}
                </v-btn>
              </v-list-item-title>
            </v-list-item>

            <v-list-item class="mt-10 pl-6">
              <v-row>
                <v-col class="sns_pc" cols="2" v-for="({icon, url}, i) in links" :key="i">
                  <a :href="url" target="_blank">
                    <v-img class="pa-3" :href="url" :src="icon" max-width="30px" max-height="30px"></v-img>
                  </a>
                </v-col>
              </v-row>
            </v-list-item>

            <v-list-item class="mt-6 pl-6">
              <v-list-item-content>
                <h4 class="pa-2">#東京メガイルミ</h4>
                <h4 class="pa-2">#大井競馬場</h4>
                <h4 class="pa-2">#nakedinc</h4>
                <h4 class="pa-2">#ネイキッドインク</h4>
              </v-list-item-content>
            </v-list-item>


          </v-list>
        </v-navigation-drawer>



        <v-app-bar v-if="!isMobileDevice()" elevation="0" class="pl-6" dark hide-on-scroll app
          style="background: rgba(0,0,0,.35)">
          <v-toolbar-title>
            <a text href="#app" v-smooth-scroll>
              <v-img :src="cp_logo_w" width="200px"></v-img>
            </a>
          </v-toolbar-title>
          <v-spacer></v-spacer>


          <div class="text-xs-caption text-sm-button mr-10">
            <v-btn text :href="menu.url" v-smooth-scroll="{ offset: -80 }" v-for="menu in menus" :key="menu.title">
              {{ menu.title }}
            </v-btn>
          </div>

          <v-list color="transparent">
            <v-list-item>
              <v-row>

                <div class="sns_pc mx-1" v-for="({icon, url}, i) in links" :key="i">
                  <a :href="url" target="_blank">
                    <v-img class="pa-3" :href="url" :src="icon" max-width="24px" max-height="24px"></v-img>
                  </a>
                </div>

              </v-row>
            </v-list-item>
          </v-list>

          <v-spacer></v-spacer>

          <v-menu offset-y bottom open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon class="pa-3">mdi-earth</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="changeLocale">
                <v-list-item-title text type="button" class="text--white">
                  {{$t("LP.change_locale")}}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>


        </v-app-bar>



        <h1>
          <!-- メインビューブロック SP表示 -->
          <v-img v-if="isMobileDevice()" :aspect-ratio="112.5/98.1" :src="kv_sp" alt=""></v-img>
        </h1>
        <h1>
          <!-- メインビューブロック PC表示-->
          <v-img v-if="!isMobileDevice()" :aspect-ratio="200/133.3" :src="kv_pc" alt=""></v-img>
        </h1>



        <!-- NakedLP.vue読み込み -->
        <NakedLP style="margin-bottom: 80px;" @change-locale="changeLocale" />


        <!-- フッター固定ボタン -->
        <v-bottom-navigation class="ar_start_button" v-if="isMobileDevice()" hide-on-scroll scroll-threshold="1000"
          fixed background-color="transparent" height="120" max-width="120"
          style="right:0; bottom: 0; left: auto; box-shadow: none;">
          <a href="#ar_buttons" v-smooth-scroll="{ offset: -80 }">
            <v-img :src="ar_start" contain width="100px"></v-img>
          </a>
        </v-bottom-navigation>

        <v-bottom-navigation class="ar_start_button" v-if="!isMobileDevice()" scroll-threshold="100" hide-on-scroll
          fixed background-color="transparent" height="200" max-width="200"
          style="right:0; bottom: 0; left: auto; box-shadow: none;">
          <a href="#ar_buttons" v-smooth-scroll="{ offset: -80 }">
            <v-img :src="ar_start" contain width="180px"></v-img>
          </a>
        </v-bottom-navigation>

      </v-main>
    </v-app>
  </div>
</template>

<script>
  import NakedLP from './components/NakedLP';
  import isMobile from "ismobilejs";

  export default {
    name: 'App',

    components: {
      NakedLP,
    },

    computed: {
      binding() {
        const binding = {}

        if (this.$vuetify.breakpoint.xsOnly) binding.row = true

        return binding
      },
      theme() {
        return this.$vuetify.theme.dark ? "dark" : "light";
      },
    },

    methods: {
      changeLocale() {
        this.$i18n.locale = (this.$i18n.locale === 'ja') ? 'en' : 'ja';
      }
    },

    data: () => ({
      // キービジュアル
      kv_sp: './Images/kv/ooi_magaillumi_kv_long_sp_03.jpg',
      kv_pc: './Images/kv/ooi_magaillumi_kv_pc_03.jpg',

      // コーポレートロゴ
      cp_logo_w: './Images/NAKED,INC._Logotype_w.svg',
      cp_logo_b: './Images/NAKED,INC._Logotype_b.svg',

      // AR Buttons
      ar_start: './Images/buttons/ooikeiba_play_button.svg',

      //キータイトル
      key_title: './Images/NAKED,INC._Logotype_w.svg',


      //メニュードロワー
      drawer: false,
      menus: [{
          title: 'Top',
          url: '#app'
        },
        {
          title: 'STORY',
          url: '#story'
        },
        {
          title: 'CONTENTS',
          url: '#contents'
        },
        {
          title: 'PRICE',
          url: '#price'
        }
      ],

      // 各種SNSのリンク
      //
      // icon => アイコン
      // url => リンク先URL
      links: [{
          icon: './Images/sns/icon_facebook.svg',
          url: 'https://www.facebook.com/NAKEDINC.official/'
        },
        {
          icon: './Images/sns/icon_twitter.svg',
          url: 'https://twitter.com/naked_staff'
        },
        {
          icon: './Images/sns/icon_line.svg',
          url: 'https://page.line.me/nakedinc'
        },
        {
          icon: './Images/sns/icon_instagram.svg',
          url: 'https://www.instagram.com/naked_inc/'
        },
        {
          icon: './Images/sns/icon_youtube.svg',
          url: 'https://www.youtube.com/c/NAKEDINC'
        },
      ],

      group: null,


      watch: {
        group() {
          this.drawer = false
        },
      },

      // PCとモバイルを切り替えるためのもの、消さないように
      isMobile,

      isMobileDevice: function () {
        if (isMobile().any) {
          return true;
        }
        return false;
      },

      // デバッグモード判定
      isDebug: false

    }),




  };
</script>


<style lang="scss">
  .footer {
    position: sticky;
    bottom: 0;
    z-index: 999;
    background: linear-gradient(180deg, rgb(138 85 241) 0%, rgb(1 140 160) 100%);
  }

  .sns_pc .v-image .v-image__image.v-image__image--cover {
    filter: brightness(100);
  }

  .ar_start_button {
    transform: translateY(100%) !important;
  }

  .v-app-bar--is-scrolled ~ .ar_start_button {
    transform: none !important;
  }
</style>